// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fuYJ","textarea":"styles_textarea__2109W"};